import toStr from './toString';
export { default as time } from './time';
export { default as fromString } from './fromString';

export const toString = toStr();
